import { PEST_TEMPLATE_ID } from "@logwave/core";

/** The quick pest look (open-pest-look / close-pest-look): one line, two outcomes. Kept apart from Pest.tsx so the checklist can ask without loading it. */
export const isQuickPestLook = (e: { key: string; templateId?: string }) => e.templateId === PEST_TEMPLATE_ID && /pest-look/.test(e.key);
